import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import { twMerge } from 'tailwind-merge';

export type Props = {
  value?: number;
  color?: 'primary' | 'success' | 'info' | 'warning' | 'error';
};

export default function CoursePathCardProgress(props: Props) {
  const { value = 0, color = 'primary' } = props;

  const progressValue = Math.round(value * 100);

  const colorClasses = {
    primary: 'progress-primary  bg-primary-content',
    success: 'progress-success bg-success-content',
    info: 'progress-info bg-info-content',
    warning: 'progress-warning bg-warning-content',
    error: 'progress-error bg-error-content',
  };

  return (
    <Tooltip text={`${progressValue}%`} classNameContainer="w-full">
      <progress
        className={twMerge('progress h-2 w-full', colorClasses[color])}
        value={progressValue}
        max={100}
      />
    </Tooltip>
  );
}
